export const AVATARS = [
  "https://images.unsplash.com/photo-1740252117013-4fb21771e7ca?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwyfHxjaGF0JTIwYXZhdGFyJTIwcG9ydHJhaXQlMjB1c2VyJTIwcHJvZmlsZXxlbnwwfHx8fDE3OTA1MTAxNDJ8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1740252117027-4275d3f84385?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHxjaGF0JTIwYXZhdGFyJTIwcG9ydHJhaXQlMjB1c2VyJTIwcHJvZmlsZXxlbnwwfHx8fDE3OTA1MTAxNDJ8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1707396172424-f3293f788364?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHw0fHxjaGF0JTIwYXZhdGFyJTIwcG9ydHJhaXQlMjB1c2VyJTIwcHJvZmlsZXxlbnwwfHx8fDE3OTA1MTAxNDJ8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1740252117012-bb53ad05e370?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwzfHxjaGF0JTIwYXZhdGFyJTIwcG9ydHJhaXQlMjB1c2VyJTIwcHJvZmlsZXxlbnwwfHx8fDE3OTA1MTAxNDJ8MA&ixlib=rb-4.1.0&q=85",
];

const PALETTE = ["#6366f1", "#10b981", "#06b6d4", "#f59e0b", "#ec4899", "#8b5cf6"];

export const colorFor = (name) => {
  let h = 0;
  for (let i = 0; i < (name || "").length; i++) h = name.charCodeAt(i) + ((h << 5) - h);
  return PALETTE[Math.abs(h) % PALETTE.length];
};

export const initials = (name) =>
  (name || "?")
    .split(" ")
    .map((w) => w[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();
